import React from 'react';

const LargePersonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="253"
    height="285"
    viewBox="0 0 253 285"
    fill="none"
  >
    <path
      d="M189.666 95.333C189.666 130.233 161.399 158.5 126.499 158.5C91.5998 158.5 63.3327 130.233 63.3327 95.333L65.0698 80.4888L15.9577 55.8538L126.499 0.583008L237.041 55.8538V134.812H221.249V63.7497L187.929 80.4888L189.666 95.333ZM126.499 190.083C196.299 190.083 252.833 218.35 252.833 253.25V284.833H0.166016V253.25C0.166016 218.35 56.7002 190.083 126.499 190.083Z"
      fill="black"
    />
  </svg>
);

export default LargePersonIcon;
